import cribIcon from '../assets/crib.png';
import appStoreIcon from '../assets/crib_ios_qr.png';
import googlePlayIcon from '../assets/crib_andr_qr.png';
import Content from './content'

function Cribbage() {
  return (
    <Content 
      icon={cribIcon}
      info={'Both Five Card and Six Card variations of cribbage are supported. As 6-card cribbage variation is the most common, it is a default variation. By default, the points will be scored automatically both during play and during show-of-cards. With Manual Scoring table option selected, both players will be forced to count their hands -- both during play and during show-of-cards. '}
      mobileLink={{
        ios: {
          qr: appStoreIcon,
          link: 'https://apps.apple.com/us/app/cribbage-live/id525215125'
        },
        android: {
          qr: googlePlayIcon,
          link: 'https://play.google.com/store/apps/details?id=com.gcgames.cribbage'
        }
      }}
    />
  );
}

export default Cribbage;